export const actionTypes = {
  setAccessToken: "SET_ACCESS_TOKEN",
  setRefreshToken: "SET_REFRESH_TOKEN",
  setAllUserDetails: "SET_All_USER_DETAILS",
  setUserDetails: "SET_USER_DETAILS",
  setAllEvents: "SET_ALL_EVENTS",
  setEventDetails: "SET_EVENT_DETAILS",
  setFormData: "SET_FORM_DATA",
  setHomeImages: "SET_HOME_IMAGES",
  setHomePageReviews: "SET_HOMEPAGE_REVIEWS",
  setEnvironmentSelected: "SET_ENVIRONMENT_SELECTED",
  setEventMetricsData: "SET_EVENT_METRICS_DATA",
  setUsersMetricsData: "SET_USERS_METRICS_DATA",
  setOrganisersMetricsData: "SET_ORGANIZERS_METRICS_DATA",
  setBookingMetricsData: "SET_BOOKING_METRICS_DATA",
  setLoginUserDetails: "LOGIN_USER_DETAILS",
  setTotalTravellersCount: "TOTAL_TRAVELLERS_COUNT",
  setTotalOrganisersCount: "TOTAL_ORGANISERS_COUNT",
  setTotalTravellersOrganisersCount: "TOTAL_TRAVELLERS_ORGANISERS_COUNT",
  setTotalEventsCount: "TOTAL_EVENTS_COUNT"

};

export const setAccessToken = (data) => {
  return {
    type: actionTypes.setAccessToken,
    payload: data,
  };
};

export const setRefreshToken = (data) => {
  return {
    type: actionTypes.setRefreshToken,
    payload: data,
  };
};
export const setAllUserDetails = (data) => {
  return {
    type: actionTypes.setAllUserDetails,
    payload: data,
  };
};

export const setUserDetails = (data) => {
  return {
    type: actionTypes.setUserDetails,
    payload: data,
  };
};

export const setAllEvents = (data) => {
  return {
    type: actionTypes.setAllEvents,
    payload: data,
  };
};

export const setEventDetails = (data) => {
  return {
    type: actionTypes.setEventDetails,
    payload: data,
  };
};

export const setFormData = (data) => {
  return {
    type: actionTypes.setFormData,
    payload: data,
  };
};

export const setHomePageReviews = (data) => {
  return {
    type: actionTypes.setHomePageReviews,
    payload: data,
  };
};

export const setEnvironmentSelected = (data) => {
  return {
    type: actionTypes.setEnvironmentSelected,
    payload: data,
  };
};

export const setEventMetricsData = (data) => {
  return {
    type: actionTypes.setEventMetricsData,
    payload: data,
  };
};

export const setUsersMetricsData = (data) => {
  return {
    type: actionTypes.setUsersMetricsData,
    payload: data,
  };
};

export const setOrganisersMetricsData = (data) => {
  return {
    type: actionTypes.setOrganisersMetricsData,
    payload: data,
  };
};

export const setBookingMetricsData = (data) => {
  return {
    type: actionTypes.setBookingMetricsData,
    payload: data,
  };
};

export const setLoginUserDetails = (data) => {
  return {
    type: actionTypes.setLoginUserDetails,
    payload: data,
  };
};

export const setTotalTravellersCount = (data) => {
  return {
    type: actionTypes.setTotalTravellersCount,
    payload: data,
  };
};

export const setTotalOrganisersCount = (data) => {
  return {
    type: actionTypes.setTotalOrganisersCount,
    payload: data,
  };
};

export const setTotalTravellersOrganisersCount = (data) => {
  return {
    type: actionTypes.setTotalTravellersOrganisersCount,
    payload: data,
  };
};
export const setTotalEventsCount = (data) => {
  return {
    type: actionTypes.setTotalEventsCount,
    payload: data,
  };
};